<template>
  <div
    class="dark:prose-invert prose prose-sm sm:prose-base md:prose-lg lg:prose-xl xl:prose-2xl prose-a:wrap-anywhere self-center"
  >
    <slot />
  </div>
</template>
